import React, { useEffect, useState } from "react";
import axios from "axios";
import {
  Button,
  Table,
  message,
  Form,
  Modal,
  Select,
  Spin,
  Space,
  Row,
  Col,
  Tooltip,
  Input,
  Card,
  Typography,
} from "antd";
import { Link, useNavigate } from "react-router-dom";
import { MdAddHome } from "react-icons/md";
import GlobalSelect from "../../generales/GlobalSelect";
import CustomFormModal from "../../components/common/CustomFormModal";
import CustomModal from "../../components/common/CustomModal";
import {
  CarOutlined,
  CheckCircleOutlined,
  CloseCircleOutlined,
  EyeOutlined,
  PlusOutlined,
  SearchOutlined,
  TrademarkOutlined,
  EditOutlined,
  DeleteOutlined,
  ReloadOutlined,
  ToolOutlined,
  PlayCircleOutlined,
  UserDeleteOutlined,
} from "@ant-design/icons";
import { AiFillAlert, AiFillDelete, AiFillEdit } from "react-icons/ai";
import { IoGolf, IoReload, IoCheckmarkCircleSharp } from "react-icons/io5";
import Search from "antd/es/input/Search";
import { useTranslation } from "react-i18next";
import _ from "lodash";

const { Title } = Typography;

export const Axios = axios.create({
  baseURL: process.env.REACT_APP_APPI_ADDRESS,
});
const { Option } = Select;

const Vehiculo = () => {
  if (sessionStorage.getItem("sessionDataStorage"))
    sessionStorage.removeItem("sessionDataStorage");

  let info_user = JSON.parse(sessionStorage.getItem("info_user"));

  const { t, i18n } = useTranslation();
  const [bottom, setBottom] = useState("bottomCenter");
  const [original, setOriginal] = useState([]);
  const [data, setData] = useState([]);
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const [spinning, setSpinning] = useState(false);
  const [spinTitle, setSpinTitle] = useState(t("global.loading"));
  const [messageApi, contextHolder] = message.useMessage();
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [loading] = useState(false);
  const [searchValue, setSearchValue] = useState(""); // Estado para controlar el valor del input
  const [selectedRow, setSelectedRow] = useState([]); // Estado para la fila seleccionada
  const [selectedRepartidorRow, setSelectedRepartidorRow] = useState([]); // Estado para la fila seleccionada
  const [isVerVisible, setIsVerVisible] = useState(false); // Estado del modal
  const [repartidorVisible, setRepartidorVisible] = useState(false); // Estado del modal
  const [repartidor, setRepartidor] = useState([]);
  const [estadoVehiculo, setEstadoVehiculo] = useState([]);
  const [tipoVehiculo, setTipoVehiculo] = useState([]);
  const [deleteButtonDisabled, setDeleteButtonDisabled] = useState(true);

  const [selectedEstadoRow, setSelectedEstadoRow] = useState([]);
  const [estadoVisible, setEstadoVisible] = useState(false);
  // const [estado, setEstado] = useState([]);

  const headers = {
    accept: "*/*",
    Authorization: "Bearer " + sessionStorage.getItem("token"),
    "Content-Type": "application/json",
  };

  useEffect(() => {
    recargar();
  }, []);

  const filterData = (data) => (formatter) =>
    data.map((item) => ({
      text: formatter(item),
      value: formatter(item),
    }));

  const columns = [
    {
      title: (
        <p
          style={{
            margin: "0px 0",
            fontSize: "15px",
            fontWeight: "bold",
            color: "#2c3e50",
            fontFamily: "'Roboto', sans-serif",
            textShadow: "1px 1px 2px rgba(0,0,0,0.2)",
          }}
        >
          {t("vehicle.marca")}
        </p>
      ),
      dataIndex: "marca",
      width: 200,
      filterSearch: true,
      filters: _.uniqWith(
        filterData(data)((i) => i.marca),
        _.isEqual
      ),
      onFilter: (value, record) => record.marca.startsWith(value),
      sorter: (a, b) => a.marca.localeCompare(b.marca),
    },
    {
      title: (
        <p
          style={{
            margin: "0px 0",
            fontSize: "15px",
            fontWeight: "bold",
            color: "#2c3e50",
            fontFamily: "'Roboto', sans-serif",
            textShadow: "1px 1px 2px rgba(0,0,0,0.2)",
          }}
        >
          {t("vehicle.modelo")}
        </p>
      ),
      dataIndex: "modelo",
      width: 200,
      filterSearch: true,
      filters: _.uniqWith(
        filterData(data)((i) => i.modelo),
        _.isEqual
      ),
      onFilter: (value, record) => record.modelo.startsWith(value),
      sorter: (a, b) => a.modelo.localeCompare(b.modelo),
    },
    {
      title: (
        <p
          style={{
            margin: "0px 0",
            fontSize: "15px",
            fontWeight: "bold",
            color: "#2c3e50",
            fontFamily: "'Roboto', sans-serif",
            textShadow: "1px 1px 2px rgba(0,0,0,0.2)",
          }}
        >
          {t("vehicle.matricula")}
        </p>
      ),
      dataIndex: "matricula",
      width: 200,
      filterSearch: true,
      filters: _.uniqWith(
        filterData(data)((i) => i.matricula),
        _.isEqual
      ),
      onFilter: (value, record) => record.matricula.startsWith(value),
      sorter: (a, b) => a.matricula.localeCompare(b.matricula),
    },
    {
      title: (
        <p
          style={{
            margin: "0px 0",
            fontSize: "15px",
            fontWeight: "bold",
            color: "#2c3e50",
            fontFamily: "'Roboto', sans-serif",
            textShadow: "1px 1px 2px rgba(0,0,0,0.2)",
          }}
        >
          {t("vehicle.capacidad_carga")}
        </p>
      ),
      dataIndex: "capacidad_carga",
      width: 240,
      filterSearch: true,
      filters: _.uniqWith(
        filterData(data)((i) => i.capacidad_carga),
        _.isEqual
      ),
      onFilter: (value, record) => record.capacidad_carga.startsWith(value),
      sorter: (a, b) => a.capacidad_carga - b.capacidad_carga,
    },
    {
      title: (
        <p
          style={{
            margin: "0px 0",
            fontSize: "15px",
            fontWeight: "bold",
            color: "#2c3e50",
            fontFamily: "'Roboto', sans-serif",
            textShadow: "1px 1px 2px rgba(0,0,0,0.2)",
          }}
        >
          {t("vehicle.longitud_carga")}
        </p>
      ),
      dataIndex: "longitud_carga",
      width: 240,
      filterSearch: true,
      filters: _.uniqWith(
        filterData(data)((i) => i.longitud_carga),
        _.isEqual
      ),
      onFilter: (value, record) => record.longitud_carga.startsWith(value),
      sorter: (a, b) => a.longitud_carga - b.longitud_carga,
    },
    {
      title: (
        <p
          style={{
            margin: "0px 0",
            fontSize: "15px",
            fontWeight: "bold",
            color: "#2c3e50",
            fontFamily: "'Roboto', sans-serif",
            textShadow: "1px 1px 2px rgba(0,0,0,0.2)",
          }}
        >
          {t("vehicle.ancho_carga")}
        </p>
      ),
      dataIndex: "ancho_carga",
      width: 230,
      filterSearch: true,
      filters: _.uniqWith(
        filterData(data)((i) => i.ancho_carga),
        _.isEqual
      ),
      onFilter: (value, record) => record.ancho_carga.startsWith(value),
      sorter: (a, b) => a.ancho_carga - b.ancho_carga,
    },
    {
      title: (
        <p
          style={{
            margin: "0px 0",
            fontSize: "15px",
            fontWeight: "bold",
            color: "#2c3e50",
            fontFamily: "'Roboto', sans-serif",
            textShadow: "1px 1px 2px rgba(0,0,0,0.2)",
          }}
        >
          {t("vehicle.altura_carga")}
        </p>
      ),
      dataIndex: "altura_carga",
      width: 230,
      filterSearch: true,
      filters: _.uniqWith(
        filterData(data)((i) => i.altura_carga),
        _.isEqual
      ),
      onFilter: (value, record) => record.altura_carga.startsWith(value),
      sorter: (a, b) => a.altura_carga - b.altura_carga,
    },
    {
      title: (
        <p
          style={{
            margin: "0px 0",
            fontSize: "15px",
            fontWeight: "bold",
            color: "#2c3e50",
            fontFamily: "'Roboto', sans-serif",
            textShadow: "1px 1px 2px rgba(0,0,0,0.2)",
          }}
        >
          {t("vehicle.tipo_vehiculo")}
        </p>
      ),
      dataIndex: "tipo_vehiculo",
      width: 200,
      filterSearch: true,
      filters: _.uniqWith(
        filterData(data)((i) => i.tipo_vehiculo),
        _.isEqual
      ),
      onFilter: (value, record) => record.tipo_vehiculo.startsWith(value),
      sorter: (a, b) => a.tipo_vehiculo.localeCompare(b.tipo_vehiculo),
    },
    {
      title: (
        <p
          style={{
            margin: "0px 0",
            fontSize: "15px",
            fontWeight: "bold",
            color: "#2c3e50",
            fontFamily: "'Roboto', sans-serif",
            textShadow: "1px 1px 2px rgba(0,0,0,0.2)",
          }}
        >
          {t("vehicle.estado")}
        </p>
      ),
      dataIndex: "estado_vehiculo",
      width: 200,
      filterSearch: true,
      filters: _.uniqWith(
        filterData(data)((i) => i.estado_vehiculo),
        _.isEqual
      ),
      onFilter: (value, record) => record.estado_vehiculo.startsWith(value),
      sorter: (a, b) => a.estado_vehiculo.localeCompare(b.estado_vehiculo),
    },
    {
      title: (
        <p
          style={{
            margin: "0px 0",
            fontSize: "15px",
            fontWeight: "bold",
            color: "#2c3e50",
            fontFamily: "'Roboto', sans-serif",
            textShadow: "1px 1px 2px rgba(0,0,0,0.2)",
          }}
        >
          {t("vehicle.subasta")}
        </p>
      ),
      dataIndex: "subasta",
      width: 200,
      render: (text) =>
        text === "1" ? (
          <IoCheckmarkCircleSharp size={20} color={"green"} />
        ) : (
          //   <IoCheckmarkCircleSharp size={20} color={"red"} />
          ""
        ),
      //   filterSearch: true,
      //   filters: _.uniqWith(
      //     filterData(data)((i) => i.subasta),
      //     _.isEqual
      //   ),
      //   onFilter: (value, record) => record.subasta.startsWith(value),
      //   sorter: (a, b) => a.subasta.localeCompare(b.subasta),
    },
  ];

  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
    total: data.length, // Asegúrate de tener el total de elementos aquí
  });

  const handleTableChange = (newPagination) => {
    setPagination({
      ...pagination,
      current: newPagination.current,
      pageSize: newPagination.pageSize,
    });
  };

  const [repartidorParams, setRepartidorParams] = useState({});
  const [formCambiarRepartidor] = Form.useForm();

  const showModalRepartidor = async () => {
    formCambiarRepartidor.resetFields();
    const row = await getInfoForm(selectedRowKeys[0]);
    setSelectedRepartidorRow(row); // Guardar la fila seleccionada
    setRepartidorVisible(true); // Mostrar el modal
  };

  const handleCancelRepartidor = () => {
    formCambiarRepartidor.resetFields();
    setRepartidorVisible(false); // Ocultar el modal
  };
  const handleFormChangeRepartidor = (changedValues, allValues) => {
    allValues = {
      idusuario: allValues.idusuario,
    };
    //console.log(allValues);
    setRepartidorParams(allValues); // Actualizar los parámetros de búsqueda conforme se llena el formulario
  };

  const handleOkAsignarRepartidor = () => {
    repartidorParams.idvehiculo = selectedRepartidorRow.idvehiculo;
    setSpinTitle(t("global.processing_data"));
    setSpinning(true);
    let message;
    Axios.post("sd/asignarRepartidor", repartidorParams, { headers }) // Se envían los parámetros de búsqueda
      .then((response) => {
        // console.log(response.data.message);
        message = response.data.message;
        setSpinning(false);
        if (response.data.success) {
          setRepartidorVisible(false); // Cerrar el modal
          messageApi.open({
            type: "success",
            content: message,
            duration: 0,
          });
          setTimeout(messageApi.destroy, 2500);
          recargar();
        } else {
          messageApi.open({ type: "error", content: message });
          setTimeout(messageApi.destroy, 3500);
        }
      })
      .catch(() => {
        setSpinning(false);
        messageApi.open({ type: "error", content: message });
        setTimeout(messageApi.destroy, 3500);
      });
  };

  const [estadoParams, setEstadoParams] = useState({});
  const [formCambiarEstado] = Form.useForm();

  const showModalEstado = async () => {
    formCambiarEstado.resetFields();
    const row = await getInfoForm(selectedRowKeys[0]);
    setSelectedEstadoRow(row); // Guardar la fila seleccionada
    setEstadoVisible(true); // Mostrar el modal
  };

  const handleCancelEstado = () => {
    formCambiarEstado.resetFields();
    setEstadoVisible(false); // Ocultar el modal
  };
  const handleFormChangeEstado = (changedValues, allValues) => {
    allValues = {
      idestadovehiculo: allValues.idestadovehiculo,
    };
    setEstadoParams(allValues); // Actualizar los parámetros de búsqueda conforme se llena el formulario
  };

  const handleOkAsignarEstado = () => {
    estadoParams.idvehiculo = selectedEstadoRow.idvehiculo;
    setSpinTitle(t("global.processing_data"));
    setSpinning(true);
    let message;
    Axios.post("sd/cambiarEstadoVehiculo", estadoParams, { headers }) // Se envían los parámetros de búsqueda
      .then((response) => {
        // console.log(response.data.message);
        message = response.data.message;
        setSpinning(false);
        if (response.data.success) {
          setEstadoVisible(false); // Cerrar el modal
          messageApi.open({
            type: "success",
            content: message,
            duration: 0,
          });
          setTimeout(messageApi.destroy, 2500);
          recargar();
        } else {
          messageApi.open({ type: "error", content: message });
          setTimeout(messageApi.destroy, 3500);
        }
      })
      .catch(() => {
        setSpinning(false);
        messageApi.open({ type: "error", content: message });
        setTimeout(messageApi.destroy, 3500);
      });
  };

  const showModalVer = async () => {
    const row = await getInfoForm(selectedRowKeys[0]);
    setSelectedRow(row); // Guardar la fila seleccionada
    setIsVerVisible(true); // Mostrar el modal
  };

  const handleCancelVer = () => {
    setIsVerVisible(false); // Ocultar el modal
  };

  const cargarRepartidor = () => {
    setSpinning(true);
    let listRepartidor = [];
    // let start = 0;
    // let limit = 1000;

    Axios.post(
      "mts/getUssers",
      {
        // "start": start,
        // "limit": limit,
        filtros: {
          idrol: 4,
        },
      },
      {
        headers: headers,
      }
    )
      .then((response) => {
        setSpinning(false);
        if (response.data.data.length > 0) {
          for (let i = 0; i < response.data.data.length; i++) {
            const user = response.data.data[i];
            if (user.activo === "1" && user.eliminado === "0") {
              listRepartidor.push({
                id: user.idusuario,
                nombre: user.fullname,
              });
            }
          }
        }
        listRepartidor = listRepartidor.filter(
          (item) =>
            item.nombre && item.nombre.trim() !== "" && item.id && item.id.trim() !== ""
        );
        setRepartidor(listRepartidor);
      })
      .catch((error) => {
        setSpinning(false);
        setRepartidor(listRepartidor);
      });
  };

  const cargarEstadoVehiculo = () => {
    setSpinning(true);
    let aux = [];
    // let start = 0;
    // let limit = 1000;

    Axios.post(
      "sd/getEstadoVehiculo",
      {
        // "start": start,
        // "limit": limit,
        // "filtros":{
        //     "idrol": 4
        // }
      },
      {
        headers: headers,
      }
    )
      .then((response) => {
        setSpinning(false);
        if (response.data.data.length > 0) {
          for (let i = 0; i < response.data.data.length; i++) {
            aux.push({
              id: response.data.data[i].idestadovehiculo,
              nombre: response.data.data[i].denominacion,
            });
          }
        }
        setEstadoVehiculo(aux);
      })
      .catch((error) => {
        setSpinning(false);
        setEstadoVehiculo(aux);
      });
  };

  const cargarTipoVehiculo = () => {
    setSpinning(true);
    let aux = [];
    // let start = 0;
    // let limit = 1000;

    Axios.post(
      "sd/getTipoVehiculo",
      {
        // "start": start,
        // "limit": limit,
        filtros: {
          activo: 1,
        },
      },
      {
        headers: headers,
      }
    )
      .then((response) => {
        setSpinning(false);
        if (response.data.data.length > 0) {
          for (let i = 0; i < response.data.data.length; i++) {
            aux.push({
              id: response.data.data[i].idtipovehiculo,
              nombre: response.data.data[i].denominacion,
            });
          }
        }
        setTipoVehiculo(aux);
      })
      .catch((error) => {
        setSpinning(false);
        setTipoVehiculo(aux);
      });
  };

  const recargar = () => {
    cargarEstadoVehiculo();
    cargarRepartidor();
    cargarTipoVehiculo();

    //limpiar la busqueda del componente Search
    setSearchValue("");

    setSpinTitle(t("global.loading"));
    setSpinning(true);
    setSelectedRowKeys([]);
    let aux = [];

    // let start = 0;
    // let limit = 1000;

    Axios.post(
      "sd/getVehiculos",
      {
        // "start": start,
        // "limit": limit,
        // "filtro":{
        //     "idrol": 1
        // }
      },
      {
        headers: headers,
      }
    )
      .then((response) => {
        if (response.data.data.length > 0) {
          for (let i = 0; i < response.data.data.length; i++) {
            aux.push({
              key: response.data.data[i].idvehiculo,
              idvehiculo: response.data.data[i].idvehiculo,
              marca: response.data.data[i].marca,
              modelo: response.data.data[i].modelo,
              matricula: response.data.data[i].matricula,
              capacidad_carga: response.data.data[i].capacidad_carga,
              longitud_carga: response.data.data[i].longitud_carga,
              ancho_carga: response.data.data[i].ancho_carga,
              altura_carga: response.data.data[i].altura_carga,
              subasta: response.data.data[i].subasta,
              comentarios: response.data.data[i].comentarios,
              fullname: response.data.data[i].fullname,
              idusuario: response.data.data[i].idusuario,
              idestadovehiculo: response.data.data[i].idestadovehiculo,
              estado_vehiculo: response.data.data[i].estado_vehiculo,
              tipo_vehiculo: response.data.data[i].tipo_vehiculo,
              idtipovehiculo: response.data.data[i].idtipovehiculo,
            });
          }
        }
        // console.table(aux);
        setData(aux);
        setOriginal(aux);
        setSpinning(false);
      })
      .catch((error) => {
        setSpinning(false);
      });
  };

  const getInfoForm = async (id) => {
    for (let i = 0; i < data.length; i++) {
      if (data[i].idvehiculo === id) {
        return data[i];
      }
    }
    return [];
  };

  const modificar = async () => {
    form.resetFields();
    const row = await getInfoForm(selectedRowKeys[0]);
    sessionStorage.setItem("sessionDataStorage", JSON.stringify(row));
  };

  const eliminar = (e) => {
    Modal.confirm({
      title: null,
      cancelText: t("global.cancel"),
      okText: t("global.save"),
      okType: "primary",
      content: (
        <div>
          <div style={{
            background: 'linear-gradient(135deg, #ff4d4f 0%, #ff7875 100%)',
            borderRadius: '12px 12px 0 0',
            padding: '24px',
            color: 'white',
            textAlign: 'center',
            marginBottom: '20px'
          }}>
            <div style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              gap: '16px'
            }}>
              <div style={{
                background: 'rgba(255,255,255,0.2)',
                borderRadius: '50%',
                width: '48px',
                height: '48px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontSize: '20px'
              }}>
                <DeleteOutlined />
              </div>
              <div>
                <Typography.Title level={3} style={{
                  color: 'white',
                  margin: 0,
                  fontSize: '20px'
                }}>
                  {t("vehicle.delete")}
                </Typography.Title>
              </div>
            </div>
          </div>
          <div style={{ padding: '0 24px' }}>
            <span>{t("vehicle.delete_data")}</span>
          </div>
        </div>
      ),
      onOk() {
        setSpinTitle(t("global.processing_data"));
        setSpinning(true);
        Axios.delete("sd/deleteVehiculos", {
          data: {
            idvehiculo: selectedRowKeys,
            nombreusuario: info_user.nombreusuario,
          },
          headers: headers,
        })
          .then((response) => {
            setSpinning(false);
            if (response.data.success) {
              messageApi.open({
                type: "success",
                content: response.data.message,
                duration: 0,
              });

              setTimeout(messageApi.destroy, 2500);
              recargar();
            } else {
              messageApi.open({
                type: "error",
                content: t("info.error"),
                duration: 0,
              });

              setTimeout(messageApi.destroy, 2500);
            }
          })
          .catch((error) => {
            setSpinning(false);
            messageApi.open({
              type: "error",
              content: t("info.error"),
              duration: 0,
            });

            setTimeout(messageApi.destroy, 2500);
          });
      },
    });
  };

  const onSearch = (value, _e, info) => {
    filterLocal(value);
  };

  const filterLocal = (value) => {
    if (value === "" || value === null) {
      setData(original);
    } else {
      let aux = [];
      original.forEach(function (option) {
        if (
          option.matricula.toUpperCase().indexOf(value.toUpperCase()) !== -1
        ) {
          aux.push(option);
        }
      });
      setData(aux);
    }
  };

  const onSelectChange = (newSelectedRowKeys) => {
    setSelectedRowKeys(newSelectedRowKeys);
    if (newSelectedRowKeys.length === 1) {
      const selectedRow = data.find((row) => row.key === newSelectedRowKeys[0]);
      if (selectedRow) {
        setDeleteButtonDisabled(
          selectedRow.idestadovehiculo != 1 && selectedRow.idestadovehiculo != 4
        );
      }
    } else {
      setDeleteButtonDisabled(true);
    }
  };
  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
  };
  const hasSelected = selectedRowKeys.length > 0;

  const selectRowUpdate = async (record) => {
    setSelectedRowKeys([record.key]);
    form.resetFields();
    let row = [];
    for (let i = 0; i < data.length; i++) {
      if (data[i].idvehiculo === record.key) {
        row = data[i];
      }
    }

    sessionStorage.setItem("sessionDataStorage", JSON.stringify(row));
    navigate(`/editVehiculo/${record.key}`);
  };

  const [isModalVisible, setIsModalVisible] = useState(false);
  const [searchParams, setSearchParams] = useState({});
  const [formSearch] = Form.useForm();

  const showModal = () => {
    formSearch.resetFields();
    setIsModalVisible(true);
  };

  const handleFormChange = (changedValues, allValues) => {
    allValues = {
      filtros: {
        marca: allValues.marca,
        modelo: allValues.modelo,
        matricula: allValues.matricula,
        capacidad_carga: allValues.capacidad_carga,
        longitud_carga: allValues.longitud_carga,
        ancho_carga: allValues.ancho_carga,
        altura_carga: allValues.altura_carga,
        idusuario: allValues.idusuario,
        idestadovehiculo: allValues.idestadovehiculo,
        idtipovehiculo: allValues.idtipovehiculo,
        comentarios: allValues.comentarios,
      },
    };
    //console.log(allValues);
    setSearchParams(allValues); // Actualizar los parámetros de búsqueda conforme se llena el formulario
  };

  const handleOk = () => {
    setSpinTitle(t("global.processing_data"));
    setSpinning(true);
    Axios.post("sd/getVehiculos", searchParams, { headers }) // Se envían los parámetros de búsqueda
      .then((response) => {
        setSpinning(false);
        if (response.data.data.length > 0) {
          const aux = response.data.data.map((resultado) => ({
            key: resultado.idvehiculo,
            idvehiculo: resultado.idvehiculo,
            marca: resultado.marca,
            modelo: resultado.modelo,
            matricula: resultado.matricula,
            capacidad_carga: resultado.capacidad_carga,
            longitud_carga: resultado.longitud_carga,
            ancho_carga: resultado.ancho_carga,
            altura_carga: resultado.altura_carga,
            comentarios: resultado.comentarios,
            estado_vehiculo: resultado.estado_vehiculo,
            tipo_vehiculo: resultado.tipo_vehiculo,
            fullname: resultado.fullname,
          }));
          setData(aux); // Actualizar la tabla con los resultados de búsqueda
        } else {
          message.warning("No se encontraron resultados.");
          setData([]);
        }
        setIsModalVisible(false); // Cerrar el modal después de realizar la búsqueda
      })
      .catch(() => {
        setSpinning(false);
        message.error("Error al realizar la búsqueda.");
      });
  };

  const handleCancel = () => {
    formSearch.resetFields();
    setIsModalVisible(false);
  };

  function activacion(e, activar) {
    Modal.confirm({
      title: null,
      cancelText: "Cancelar",
      okText: "Aceptar",
      okType: "primary",
      content: (
        <div>
          <div style={{
            background: activar
              ? 'linear-gradient(135deg, #27ae60 0%, #2ecc71 100%)'
              : 'linear-gradient(135deg, #e67e22 0%, #f39c12 100%)',
            borderRadius: '12px 12px 0 0',
            padding: '24px',
            color: 'white',
            textAlign: 'center',
            marginBottom: '20px'
          }}>
            <div style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              gap: '16px'
            }}>
              <div style={{
                background: 'rgba(255,255,255,0.2)',
                borderRadius: '50%',
                width: '48px',
                height: '48px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontSize: '20px'
              }}>
                {activar ? <CheckCircleOutlined /> : <CloseCircleOutlined />}
              </div>
              <div>
                <Typography.Title level={3} style={{
                  color: 'white',
                  margin: 0,
                  fontSize: '20px'
                }}>
                  {activar ? "Activar Subasta" : "Desactivar Subasta"}
                </Typography.Title>
              </div>
            </div>
          </div>
          <div style={{ padding: '0 24px' }}>
            <span>
              ¿Desea {activar ? "activar" : "desactivar"} subasta para el vehículo
              seleccionado?
            </span>
          </div>
        </div>
      ),
      onOk() {
        setSpinTitle(
          activar ? "Activando Subasta..." : "Desactivando Subasta..."
        );
        setSpinning(true);
        Axios.post(
          "sd/activarDesactivarSubasta",
          {
            idvehiculo: selectedRowKeys[0],
            subasta: activar ? 1 : 0,
          },
          {
            headers: headers,
          }
        )
          .then((response) => {
            setSpinning(false);
            if (response.data.success) {
              messageApi.open({
                type: "success",
                content: activar
                  ? "Subasta activado satisfactoriamente"
                  : "Subasta desactivado satisfactoriamente",
                duration: 0,
              });

              setTimeout(messageApi.destroy, 2500);
              recargar();
            } else {
              messageApi.open({
                type: "error",
                content: activar
                  ? "Error activando Subasta"
                  : "Error desactivando Subasta",
                duration: 0,
              });

              setTimeout(messageApi.destroy, 2500);
            }
          })
          .catch((error) => {
            setSpinning(false);
            messageApi.open({
              type: "error",
              content: activar
                ? "Error activando Subasta"
                : "Error desactivando Subasta",
              duration: 0,
            });

            setTimeout(messageApi.destroy, 2500);
          });
      },
    });
  }

  return (
    <div style={{
      minHeight: "100vh",
      background: 'linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)',
      padding: "16px"
    }}>
      <Spin spinning={spinning} tip={spinTitle} size={"large"}>
        {/* Header */}
        <div style={{
          background: 'linear-gradient(135deg, #253289 0%, #4a5acf 100%)',
          borderRadius: '8px',
          padding: '12px',
          marginBottom: '12px',
          color: 'white'
        }}>
          <div style={{
            display: 'flex',
            alignItems: 'center',
            gap: '16px'
          }}>
            <div style={{
              background: 'rgba(255,255,255,0.2)',
              borderRadius: '50%',
              width: '24px',
              height: '24px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              fontSize: '12px'
            }}>
              <CarOutlined />
            </div>
            <div style={{ flex: 1 }}>
              <Title level={4} style={{
                color: 'white',
                margin: 0,
                fontSize: '16px'
              }}>
                {t("vehicle.title")}
              </Title>
              <p style={{
                color: 'rgba(255,255,255,0.8)',
                margin: 0,
                fontSize: '12px'
              }}>
                Gestión de vehículos • {data.length} vehículos
              </p>
            </div>
            <div style={{
              background: 'rgba(255,255,255,0.2)',
              borderRadius: '8px',
              padding: '8px 16px'
            }}>
              <p style={{ color: 'white', margin: 0, fontSize: '14px', fontWeight: 'bold' }}>
                {data.length} vehículos
              </p>
            </div>
          </div>
        </div>
        {contextHolder}

        {/* Status Cards */}
        <Row gutter={[8, 8]} style={{ marginBottom: '12px' }}>
          <Col xs={24} sm={12} md={6}>
            <Card style={{
              height: '80px',
              borderRadius: '8px',
              boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
              border: 'none',
              background: 'linear-gradient(135deg, #3B49B2 0%, #5A6ACF 100%)',
              color: 'white'
            }} styles={{ body: { padding: '8px', height: '100%' } }}>
              <div style={{ textAlign: 'center', height: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
                <div style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  gap: '8px',
                  marginBottom: '4px'
                }}>
                  <CheckCircleOutlined style={{
                    fontSize: '18px',
                    color: 'rgba(255,255,255,0.9)'
                  }} />
                  <div style={{
                    fontSize: '24px',
                    fontWeight: 'bold',
                    textShadow: '2px 2px 4px rgba(0,0,0,0.2)'
                  }}>
                    {data.filter(item => item.idestadovehiculo === "1").length}
                  </div>
                </div>
                <div style={{
                  fontSize: '12px',
                  fontWeight: '500',
                  opacity: 0.9
                }}>
                  Disponible
                </div>
              </div>
            </Card>
          </Col>
          <Col xs={24} sm={12} md={6}>
            <Card style={{
              height: '80px',
              borderRadius: '8px',
              boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
              border: 'none',
              background: 'linear-gradient(135deg, #3B49B2 0%, #5A6ACF 100%)',
              color: 'white'
            }} styles={{ body: { padding: '8px', height: '100%' } }}>
              <div style={{ textAlign: 'center', height: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
                <div style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  gap: '8px',
                  marginBottom: '4px'
                }}>
                  <ToolOutlined style={{
                    fontSize: '18px',
                    color: 'rgba(255,255,255,0.9)'
                  }} />
                  <div style={{
                    fontSize: '24px',
                    fontWeight: 'bold',
                    textShadow: '2px 2px 4px rgba(0,0,0,0.2)'
                  }}>
                    {data.filter(item => item.idestadovehiculo === "2").length}
                  </div>
                </div>
                <div style={{
                  fontSize: '12px',
                  fontWeight: '500',
                  opacity: 0.9
                }}>
                  En mantenimiento
                </div>
              </div>
            </Card>
          </Col>
          <Col xs={24} sm={12} md={6}>
            <Card style={{
              height: '80px',
              borderRadius: '8px',
              boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
              border: 'none',
              background: 'linear-gradient(135deg, #3B49B2 0%, #5A6ACF 100%)',
              color: 'white'
            }} styles={{ body: { padding: '8px', height: '100%' } }}>
              <div style={{ textAlign: 'center', height: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
                <div style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  gap: '8px',
                  marginBottom: '4px'
                }}>
                  <PlayCircleOutlined style={{
                    fontSize: '18px',
                    color: 'rgba(255,255,255,0.9)'
                  }} />
                  <div style={{
                    fontSize: '24px',
                    fontWeight: 'bold',
                    textShadow: '2px 2px 4px rgba(0,0,0,0.2)'
                  }}>
                    {data.filter(item => item.idestadovehiculo === "3").length}
                  </div>
                </div>
                <div style={{
                  fontSize: '12px',
                  fontWeight: '500',
                  opacity: 0.9
                }}>
                  En uso
                </div>
              </div>
            </Card>
          </Col>
          <Col xs={24} sm={12} md={6}>
            <Card style={{
              height: '80px',
              borderRadius: '8px',
              boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
              border: 'none',
              background: 'linear-gradient(135deg, #3B49B2 0%, #5A6ACF 100%)',
              color: 'white'
            }} styles={{ body: { padding: '8px', height: '100%' } }}>
              <div style={{ textAlign: 'center', height: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
                <div style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  gap: '8px',
                  marginBottom: '4px'
                }}>
                  <UserDeleteOutlined style={{
                    fontSize: '18px',
                    color: 'rgba(255,255,255,0.9)'
                  }} />
                  <div style={{
                    fontSize: '24px',
                    fontWeight: 'bold',
                    textShadow: '2px 2px 4px rgba(0,0,0,0.2)'
                  }}>
                    {data.filter(item => item.idestadovehiculo === "4").length}
                  </div>
                </div>
                <div style={{
                  fontSize: '12px',
                  fontWeight: '500',
                  opacity: 0.9
                }}>
                  No repartidor
                </div>
              </div>
            </Card>
          </Col>
        </Row>

        {/* Toolbar */}
        <Card style={{
          marginBottom: '12px',
          borderRadius: '8px',
          boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
          border: 'none'
        }}>
          <div style={{
            display: 'flex',
            flexWrap: 'wrap',
            gap: '4px',
            alignItems: 'center'
          }}>
            <Link to="/addVehiculo">
              <Button
                type="primary"
                icon={<PlusOutlined />}
                disabled={loading}
                size="small"
                style={{
                  background: loading
                    ? '#d9d9d9'
                    : 'linear-gradient(135deg, #253289 0%, #4a5acf 100%)',
                  borderColor: loading ? '#d9d9d9' : '#253289',
                  borderRadius: '8px',
                  height: '32px',
                  fontWeight: '500',
                  color: loading ? '#000000' : 'white',
                  boxShadow: loading ? 'none' : '0 2px 8px rgba(37, 50, 137, 0.3)'
                }}
              >
                {t("vehicle.add")}
              </Button>
            </Link>
            <Link to={`/editVehiculo/${selectedRowKeys[0]}`}>
              <Button
                type="primary"
                icon={<EditOutlined />}
                onClick={modificar}
                disabled={loading || selectedRowKeys.length !== 1}
                size="small"
                style={{
                  background: (loading || selectedRowKeys.length !== 1)
                    ? '#d9d9d9'
                    : 'linear-gradient(135deg, #253289 0%, #4a5acf 100%)',
                  borderColor: (loading || selectedRowKeys.length !== 1) ? '#d9d9d9' : '#253289',
                  borderRadius: '8px',
                  height: '32px',
                  fontWeight: '500',
                  color: (loading || selectedRowKeys.length !== 1) ? '#000000' : 'white',
                  boxShadow: (loading || selectedRowKeys.length !== 1) ? 'none' : '0 2px 8px rgba(37, 50, 137, 0.3)'
                }}
              >
                {t("vehicle.edit")}
              </Button>
            </Link>
            <Button
              type="primary"
              icon={<TrademarkOutlined />}
              onClick={showModalRepartidor}
              disabled={!hasSelected || loading || selectedRowKeys.length !== 1}
              size="small"
              style={{
                background: (!hasSelected || loading || selectedRowKeys.length !== 1)
                  ? '#d9d9d9'
                  : 'linear-gradient(135deg, #253289 0%, #4a5acf 100%)',
                borderColor: (!hasSelected || loading || selectedRowKeys.length !== 1) ? '#d9d9d9' : '#253289',
                borderRadius: '8px',
                height: '32px',
                fontWeight: '500',
                color: (!hasSelected || loading || selectedRowKeys.length !== 1) ? '#000000' : 'white',
                boxShadow: (!hasSelected || loading || selectedRowKeys.length !== 1) ? 'none' : '0 2px 8px rgba(37, 50, 137, 0.3)'
              }}
            >
              Asignar Repartidor
            </Button>
            <Button
              type="primary"
              icon={<IoGolf />}
              onClick={showModalEstado}
              disabled={!hasSelected || loading || selectedRowKeys.length !== 1}
              size="small"
              style={{
                background: (!hasSelected || loading || selectedRowKeys.length !== 1)
                  ? '#d9d9d9'
                  : 'linear-gradient(135deg, #253289 0%, #4a5acf 100%)',
                borderColor: (!hasSelected || loading || selectedRowKeys.length !== 1) ? '#d9d9d9' : '#253289',
                borderRadius: '8px',
                height: '32px',
                fontWeight: '500',
                color: (!hasSelected || loading || selectedRowKeys.length !== 1) ? '#000000' : 'white',
                boxShadow: (!hasSelected || loading || selectedRowKeys.length !== 1) ? 'none' : '0 2px 8px rgba(37, 50, 137, 0.3)'
              }}
            >
              Cambiar Estado
            </Button>
            <Button
              type="primary"
              icon={<EyeOutlined />}
              onClick={showModalVer}
              disabled={!hasSelected || loading || selectedRowKeys.length !== 1}
              size="small"
              style={{
                background: (!hasSelected || loading || selectedRowKeys.length !== 1)
                  ? '#d9d9d9'
                  : 'linear-gradient(135deg, #253289 0%, #4a5acf 100%)',
                borderColor: (!hasSelected || loading || selectedRowKeys.length !== 1) ? '#d9d9d9' : '#253289',
                borderRadius: '8px',
                height: '32px',
                fontWeight: '500',
                color: (!hasSelected || loading || selectedRowKeys.length !== 1) ? '#000000' : 'white',
                boxShadow: (!hasSelected || loading || selectedRowKeys.length !== 1) ? 'none' : '0 2px 8px rgba(37, 50, 137, 0.3)'
              }}
            >
              Ver Detalles
            </Button>
            <Button
              type="primary"
              icon={<CheckCircleOutlined />}
              onClick={(e) => { activacion(e, true); }}
              disabled={loading || selectedRowKeys.length !== 1}
              size="small"
              style={{
                background: (loading || selectedRowKeys.length !== 1)
                  ? '#d9d9d9'
                  : 'linear-gradient(135deg, #52c41a 0%, #73d13d 100%)',
                borderColor: (loading || selectedRowKeys.length !== 1) ? '#d9d9d9' : '#52c41a',
                borderRadius: '8px',
                height: '32px',
                fontWeight: '500',
                color: (loading || selectedRowKeys.length !== 1) ? '#000000' : 'white',
                boxShadow: (loading || selectedRowKeys.length !== 1) ? 'none' : '0 2px 8px rgba(82, 196, 26, 0.3)'
              }}
            >
              {t("vehicle.activate_subasta")}
            </Button>
            <Button
              danger
              icon={<CloseCircleOutlined />}
              onClick={(e) => { activacion(e, false); }}
              disabled={loading || selectedRowKeys.length !== 1}
              size="small"
              style={{
                borderRadius: '8px',
                height: '32px',
                fontWeight: '500',
                background: (loading || selectedRowKeys.length !== 1) ? '#d9d9d9' : '#ff4d4f',
                borderColor: (loading || selectedRowKeys.length !== 1) ? '#d9d9d9' : '#ff4d4f',
                color: (loading || selectedRowKeys.length !== 1) ? '#000000' : 'white'
              }}
            >
              {t("vehicle.deactivate_subasta")}
            </Button>
            <Button
              danger
              icon={<DeleteOutlined />}
              onClick={eliminar}
              disabled={deleteButtonDisabled}
              size="small"
              style={{
                borderRadius: '8px',
                height: '32px',
                fontWeight: '500',
                background: deleteButtonDisabled ? '#d9d9d9' : '#ff4d4f',
                borderColor: deleteButtonDisabled ? '#d9d9d9' : '#ff4d4f',
                color: deleteButtonDisabled ? '#000000' : 'white'
              }}
            >
              {t("vehicle.delete")}
            </Button>
            <Button
              type="primary"
              icon={<SearchOutlined />}
              onClick={showModal}
              size="small"
              style={{
                background: 'linear-gradient(135deg, #253289 0%, #4a5acf 100%)',
                borderColor: '#253289',
                borderRadius: '8px',
                height: '32px',
                fontWeight: '500',
                boxShadow: '0 2px 8px rgba(37, 50, 137, 0.3)'
              }}
            >
              Búsqueda avanzada
            </Button>
            <Button
              type="primary"
              icon={<ReloadOutlined />}
              onClick={recargar}
              loading={loading}
              size="small"
              style={{
                background: 'linear-gradient(135deg, #253289 0%, #4a5acf 100%)',
                borderColor: '#253289',
                borderRadius: '8px',
                height: '32px',
                fontWeight: '500',
                boxShadow: '0 2px 8px rgba(37, 50, 137, 0.3)'
              }}
            >
              {t("vehicle.update")}
            </Button>
          </div>
        </Card>

          <CustomFormModal
            open={repartidorVisible}
            onCancel={handleCancelRepartidor}
            onOk={() => {
              formCambiarRepartidor
                .validateFields()
                .then((values) => {
                  handleOkAsignarRepartidor(values);
                })
                .catch((info) => {
                  console.log("Validación fallida:", info);
                });
            }}
            title="Cambiar Repartidor"
            subtitle="Asignar un nuevo repartidor al vehículo"
            icon={<TrademarkOutlined />}
            width={600}
          >
            <Form
              form={formCambiarRepartidor}
              onValuesChange={handleFormChangeRepartidor}
              layout="vertical"
            >
              <Form.Item
                name="idusuario"
                label={t("vehicle.repartidor")}
                rules={[
                  {
                    required: true,
                    message: "Por favor, seleccione un repartidor!",
                  },
                ]}
              >
                <GlobalSelect
                  loading={spinning}
                  valueName={"idusuario"}
                  data={repartidor}
                  style={{ height: '40px' }}
                />
              </Form.Item>
            </Form>
          </CustomFormModal>

          <CustomFormModal
            open={estadoVisible}
            onCancel={handleCancelEstado}
            onOk={() => {
              formCambiarEstado
                .validateFields()
                .then((values) => {
                  handleOkAsignarEstado(values);
                })
                .catch((info) => {
                  console.log("Validación fallida:", info);
                });
            }}
            title="Cambiar Estado"
            subtitle="Modificar el estado del vehículo"
            icon={<ToolOutlined />}
            okText="Guardar"
            cancelText="Cancelar"
            width={600}
          >
            <Form
              form={formCambiarEstado}
              onValuesChange={handleFormChangeEstado}
              layout="vertical"
            >
              <Form.Item
                name="idestadovehiculo"
                label={t("vehicle.estado")}
                rules={[
                  {
                    required: true,
                    message: "Por favor, seleccione un estado!",
                  },
                ]}
              >
                <GlobalSelect
                  loading={spinning}
                  valueName={"idestadovehiculo"}
                  data={estadoVehiculo.filter((item) => item.id !== "3")}
                  style={{ height: '40px' }}
                />
              </Form.Item>
            </Form>
          </CustomFormModal>

          <CustomModal
            open={isVerVisible}
            onCancel={handleCancelVer}
            title="Detalles del Vehículo"
            subtitle="Información completa del vehículo seleccionado"
            icon={<EyeOutlined />}
            width={800}
          >
            {selectedRow && (
                  <>
                    {/* Información General */}
                    <div style={{
                      background: 'linear-gradient(135deg, #f8f9fc 0%, #e8ebf7 100%)',
                      borderRadius: '12px',
                      padding: '20px',
                      marginBottom: '20px',
                      border: '1px solid #e0e6ff'
                    }}>
                      <Title level={4} style={{ color: '#253289', marginBottom: '16px', fontSize: '16px' }}>
                        🚗 Información General
                      </Title>
                      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: '12px' }}>
                        <div><strong>Marca:</strong> <span style={{ color: '#666' }}>{selectedRow.marca}</span></div>
                        <div><strong>Modelo:</strong> <span style={{ color: '#666' }}>{selectedRow.modelo}</span></div>
                        <div><strong>Matrícula:</strong> <span style={{ color: '#666' }}>{selectedRow.matricula}</span></div>
                        <div><strong>Tipo Vehículo:</strong> <span style={{ color: '#666' }}>{selectedRow.tipo_vehiculo}</span></div>
                        <div><strong>Estado:</strong> <span style={{ color: '#666' }}>{selectedRow.estado_vehiculo}</span></div>
                      </div>
                    </div>

                    {/* Especificaciones de Carga */}
                    <div style={{
                      background: 'linear-gradient(135deg, #f8f9fc 0%, #e8ebf7 100%)',
                      borderRadius: '12px',
                      padding: '20px',
                      marginBottom: '20px',
                      border: '1px solid #e0e6ff'
                    }}>
                      <Title level={4} style={{ color: '#253289', marginBottom: '16px', fontSize: '16px' }}>
                        📏 Especificaciones de Carga
                      </Title>
                      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: '12px' }}>
                        <div><strong>Capacidad de carga:</strong> <span style={{ color: '#666' }}>{selectedRow.capacidad_carga}</span></div>
                        <div><strong>Longitud carga:</strong> <span style={{ color: '#666' }}>{selectedRow.longitud_carga}</span></div>
                        <div><strong>Ancho carga:</strong> <span style={{ color: '#666' }}>{selectedRow.ancho_carga}</span></div>
                        <div><strong>Altura carga:</strong> <span style={{ color: '#666' }}>{selectedRow.altura_carga}</span></div>
                      </div>
                    </div>

                    {/* Asignación y Comentarios */}
                    <div style={{
                      background: 'linear-gradient(135deg, #f8f9fc 0%, #e8ebf7 100%)',
                      borderRadius: '12px',
                      padding: '20px',
                      border: '1px solid #e0e6ff'
                    }}>
                      <Title level={4} style={{ color: '#253289', marginBottom: '16px', fontSize: '16px' }}>
                        👤 Asignación y Notas
                      </Title>
                      <div style={{ display: 'grid', gridTemplateColumns: '1fr', gap: '12px' }}>
                        <div><strong>Repartidor:</strong> <span style={{ color: '#666' }}>{selectedRow.fullname || 'No asignado'}</span></div>
                        <div><strong>Comentarios:</strong> <span style={{ color: '#666' }}>{selectedRow.comentarios || 'Sin comentarios'}</span></div>
                      </div>
                    </div>
                  </>
            )}
          </CustomModal>

          <CustomModal
            open={isModalVisible}
            onCancel={handleCancel}
            title={t("global.search")}
            subtitle="Buscar vehículos con criterios específicos"
            icon={<SearchOutlined />}
            width={800}
            footer={
              <div style={{
                textAlign: 'center',
                padding: '16px 24px',
                borderTop: '1px solid #f0f0f0',
                marginTop: '24px'
              }}>
                <Button
                  key="cancel"
                  onClick={handleCancel}
                  style={{
                    marginRight: 12,
                    height: '40px',
                    borderRadius: '8px',
                    fontWeight: '500'
                  }}
                >
                  Cancelar
                </Button>
                <Button
                  key="search"
                  type="primary"
                  onClick={handleOk}
                  style={{
                    background: 'linear-gradient(135deg, #253289 0%, #4a5acf 100%)',
                    borderColor: '#253289',
                    height: '40px',
                    borderRadius: '8px',
                    fontWeight: '500',
                    boxShadow: '0 2px 8px rgba(37, 50, 137, 0.3)'
                  }}
                >
                  Buscar
                </Button>
              </div>
            }
          >
            <Form
              layout="vertical"
              form={formSearch}
              onValuesChange={handleFormChange}
            >
              <Row gutter={16}>
                <Col span={8}>
                  <Form.Item name="marca" label={t("vehicle.marca")}>
                    <Input placeholder="Ingrese la marca" />
                  </Form.Item>
                </Col>
                <Col span={8}>
                  <Form.Item name="modelo" label={t("vehicle.modelo")}>
                    <Input placeholder="Ingrese el modelo" />
                  </Form.Item>
                </Col>
                <Col span={8}>
                  <Form.Item name="matricula" label={t("vehicle.matricula")}>
                    <Input placeholder="Ingrese la matrícula" />
                  </Form.Item>
                </Col>
              </Row>
              <Row gutter={16}>
                <Col span={8}>
                  <Form.Item
                    name="capacidad_carga"
                    label={t("vehicle.capacidad_carga")}
                  >
                    <Input placeholder="Ingrese la capacidad de carga" />
                  </Form.Item>
                </Col>
                <Col span={8}>
                  <Form.Item
                    name="longitud_carga"
                    label={t("vehicle.longitud_carga")}
                  >
                    <Input placeholder="Ingrese la longitud de carga" />
                  </Form.Item>
                </Col>
                <Col span={8}>
                  <Form.Item
                    name="ancho_carga"
                    label={t("vehicle.ancho_carga")}
                  >
                    <Input placeholder="Ingrese la ancho de carga" />
                  </Form.Item>
                </Col>
              </Row>
              <Row gutter={16}>
                <Col span={8}>
                  <Form.Item
                    name="altura_carga"
                    label={t("vehicle.altura_carga")}
                  >
                    <Input placeholder="Ingrese la altura de carga" />
                  </Form.Item>
                  <Form.Item
                    name="idtipovehiculo"
                    label={t("vehicle.tipo_vehiculo")}
                  >
                    <GlobalSelect
                      loading={spinning}
                      valueName={"idtipovehiculo"}
                      data={tipoVehiculo}
                    />
                  </Form.Item>
                </Col>
                <Col span={8}>
                  <Form.Item name="idusuario" label={t("vehicle.repartidor")}>
                    <GlobalSelect
                      loading={spinning}
                      valueName={"idusuario"}
                      data={repartidor}
                    />
                  </Form.Item>
                </Col>
                <Col span={8}>
                  <Form.Item
                    name="idestadovehiculo"
                    label={t("vehicle.estado")}
                  >
                    <GlobalSelect
                      loading={spinning}
                      valueName={"idestadovehiculo"}
                      data={estadoVehiculo}
                    />
                  </Form.Item>
                </Col>
              </Row>
              <Row gutter={16}>
                <Col span={24}>
                  <Form.Item
                    name="comentarios"
                    label={t("vehicle.comentarios")}
                  >
                    <Input.TextArea placeholder="Ingrese la nota adicional" />
                  </Form.Item>
                </Col>
              </Row>
            </Form>
          </CustomModal>

        {/* Table */}
        <Card style={{
          borderRadius: '8px',
          boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
          border: 'none'
        }}>
          {/* Filtro de búsqueda */}
          <div style={{
            marginBottom: '12px',
            display: 'flex',
            justifyContent: 'flex-start',
            alignItems: 'center',
            gap: '8px'
          }}>
            <Input
              placeholder="Buscar por matrícula..."
              prefix={<SearchOutlined />}
              value={searchValue}
              onChange={(e) => {
                setSearchValue(e.target.value);
                filterLocal(e.target.value);
              }}
              style={{
                width: '250px',
                borderRadius: '8px',
                boxShadow: '0 2px 8px rgba(0,0,0,0.1)'
              }}
              size="small"
            />
            {searchValue && (
              <Button
                type="text"
                icon={<CloseCircleOutlined />}
                onClick={() => {
                  setSearchValue("");
                  filterLocal("");
                }}
                style={{
                  color: '#666',
                  borderRadius: '6px'
                }}
                size="small"
              >
                Limpiar
              </Button>
            )}
          </div>

          <Table
            size="small"
            scroll={{ x: 1500, y: 500 }}
            bordered={false}
            pagination={{
              position: [bottom],
              current: pagination.current,
              pageSize: pagination.pageSize,
              showSizeChanger: true,
              pageSizeOptions: ["5", "10", "20", "50", "100"],
              showTotal: (total) => `Total ${total} elementos`,
            }}
            onChange={handleTableChange}
            rowSelection={rowSelection}
            columns={[
              {
                title: (
                  <p
                    style={{
                      margin: "0px 0",
                      fontSize: "15px",
                      fontWeight: "bold",
                      color: "#2c3e50",
                      fontFamily: "'Roboto', sans-serif",
                      textShadow: "1px 1px 2px rgba(0,0,0,0.2)",
                    }}
                  >
                    {t("vehicle.matricula")}
                  </p>
                ),
                dataIndex: "matricula",
                key: "matricula",
                width: 220,
                render: (text) => (
                  <span style={{ fontWeight: '500', color: '#253289' }}>{text}</span>
                )
              },
              ...columns.slice(1)
            ]}
            dataSource={data}
            onRow={(record) => {
              return {
                onDoubleClick: async () => {
                  // selectRowUpdate(record);
                },
              };
            }}
            expandable={{
              expandedRowRender: (record) => (
                <div style={{
                  background: 'linear-gradient(135deg, #f8f9fc 0%, #e8ebf7 100%)',
                  padding: '16px',
                  borderRadius: '8px',
                  margin: '8px 0'
                }}>
                  <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: '12px' }}>
                    <div><strong style={{ color: '#253289' }}>Repartidor:</strong> <span style={{ color: '#666' }}>{record.fullname || 'No asignado'}</span></div>
                    <div style={{ gridColumn: '1 / -1' }}><strong style={{ color: '#253289' }}>Comentarios:</strong> <span style={{ color: '#666' }}>{record.comentarios || 'Sin comentarios'}</span></div>
                  </div>
                </div>
              ),
              rowExpandable: (record) => record.comentarios !== "Not Expandable",
            }}
          />
        </Card>
      </Spin>
    </div>
  );
};
export default Vehiculo;
